import { useCallback } from 'react';

import useLocalStorage from './useLocalStorage';

/* A small custom hook to manage ag grid column state persistence. 
  It handles column order, visibility , etc. Provides a option to save sortOrder which defaults to false.
*/
export const useAgGridPersistColumnState = ({ key, gridRef, saveSortOrder = false }) => {
  const [persistedGridState, setPersistedGridState] = useLocalStorage(key, null);

  const persistedColumnState = persistedGridState?.columnState;

  const saveColumnState = useCallback(() => {
    const currentColumnState = gridRef?.current?.api?.getColumnState();

    /* 
      in case when currentColumnState is not an array, 
      we don't want to save anything to LS 
      */
    if (!Array.isArray(currentColumnState)) return;

    /* in case we want to don't want to save sort order */
    const mappedColumnState = currentColumnState.map(({ colId, hide, sort, sortIndex }) => ({
      colId,
      hide,
      sort: saveSortOrder ? sort : null,
      sortIndex: saveSortOrder ? sortIndex : null,
    }));

    setPersistedGridState((prev) => ({ ...prev, columnState: mappedColumnState }));
  }, [setPersistedGridState, saveSortOrder, gridRef]);

  const loadColumnState = useCallback(() => {
    /* Read from localStorage */
    if (persistedColumnState) {
      gridRef?.current?.api?.applyColumnState({
        state: persistedColumnState,
        applyOrder: true,
      });
    }
  }, [persistedColumnState, gridRef]);

  return {
    persistedColumnState,
    saveColumnState,
    loadColumnState,
  };
};
